export default __webpack_public_path__ + "static/media/8.472482e1.png";